import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { sfAuth } from './SFAuth';
import { Box, CircularProgress } from '@mui/material';

interface RequireAuthProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ 
  children, 
  redirectTo = '/login' 
}) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Always attempt getAccessToken — it will refresh an expired access token
        // using the refresh token if available. Don't gate on isAuthenticated()
        // which only checks access token expiry and would skip the refresh.
        const token = await sfAuth.getAccessToken();
        setIsAuthenticated(!!token);
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, []);

  if (isChecking) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Save the attempted location
    const state = { from: location.pathname + location.search };
    return <Navigate to={redirectTo} state={state} replace />;
  }

  return <>{children}</>;
};